<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :append-to-body="false"
      width="316px"
      title='提示'
      custom-class="cw-dialog"
      top='300px'
       :close-on-click-modal='false'
    >
      <div>{{title}}</div>
      <div>{{subtitle}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:{
    dialogVisible:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:''
    },
    subtitle:{
       type:String,
       default:''
    },
    dialogParams:{
      default:''
    }

  },
  data() {
    return {
      
    };
  },
  methods: {
    handleClose() {
      this.$emit('dialogCancle',false)
    },
    dialogSubmit() {
      let params=this.dialogParams;
      this.$emit('dialogSuccess',params)
    }
  }
};
</script>

<style  lang="scss">
.cw-dialog {
  .el-dialog__header {
    height: 45px;
    background: linear-gradient(
      90deg,
      rgba(76, 184, 255, 1) 0%,
      rgba(84, 144, 255, 1) 100%
    );
    padding: 0px;
    .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #fff;
    line-height: 50px;
    padding-left: 20px;
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: 16px;
      right: 20px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
      .el-dialog__close {
        color: #fff;
        &:hover {
          color: #fff;
        }
      }
    }
  }
  .el-dialog__body {
    padding: 30px 20px;
    font-size: 14px;
    color: #0084FF;
    text-align: center;
  }
  .el-dialog__footer{
    text-align: center;
    .el-button {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #DCDFE6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      -webkit-transition: .1s;
      transition: .1s;
      font-weight: 500;
      font-size: 14px;
      border-radius: 4px;
      width: 90px;
      height: 30px;
      line-height: 30px;
      padding: 0px;
    }
    .el-button:nth-child(1){
      margin-right: 38px;
      background: #E5E5E5;
      color: #333333;
    }
    .el-button:nth-child(2){
      background: #0084FF;
      color: #fff;
    }
  }
}
</style>